import React, { forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  addon?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, addon, className = '', ...props }, ref) => {
    return (
      <div className="mb-5">
        <label className="block text-xs font-medium tracking-wider mb-2.5 uppercase">
          {label}
        </label>
        <div className="relative">
          <input
            ref={ref}
            className={`w-full py-3.5 border-0 border-b border-border text-base bg-transparent transition-colors focus:outline-none focus:border-primary placeholder:text-[#CCCCCC] ${className}`}
            {...props}
          />
          {addon && (
            <span className="absolute right-0 bottom-3.5 text-secondary text-sm">
              {addon}
            </span>
          )}
        </div>
        {error && (
          <div className="text-[#D32F2F] text-xs mt-2">{error}</div>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
